import { SuspectScoreQuantiles } from 'models/event'

export type SuspectScoreDisplayProps = {
  activeLine?: 'green' | 'yellow' | 'red'
  tickPosition?: string
  tickColor?: string
  tickText?: string
  footerText?: string
}

export function calculateSuspectScoreDisplayProps(
  score?: number,
  quantiles?: SuspectScoreQuantiles
): SuspectScoreDisplayProps {
  if (
    score == null ||
    quantiles == null ||
    quantiles.p25 == null ||
    quantiles.p50 == null ||
    quantiles.p75 == null ||
    quantiles.p95 == null
  ) {
    return {}
  }

  if (score <= quantiles?.p25) {
    return {
      activeLine: 'green',
      tickColor: 'bg-green-900',
      tickPosition: 'left-[calc(25%-8px)]',
      tickText: '≤ P25',
      footerText: `A score of ${score} is less than or equal to the scores of 25% of recent visitors.`,
    }
  }

  if (score <= quantiles?.p50) {
    return {
      activeLine: 'green',
      tickColor: 'bg-green-900',
      tickPosition: 'left-[calc(50%-8px)]',
      tickText: '≤ P50',
      footerText: `A score of ${score} is less than or equal to the scores of 50% of recent visitors.`,
    }
  }

  if (score <= quantiles?.p75) {
    return {
      activeLine: 'green',
      tickColor: 'bg-green-900',
      tickPosition: 'left-[calc(75%-8px)]',
      tickText: '≤ P75',
      footerText: `A score of ${score} is less than or equal to the scores of 75% of recent visitors.`,
    }
  }

  if (score <= quantiles?.p95) {
    return {
      activeLine: 'yellow',
      tickColor: 'bg-yellow-900',
      tickPosition: 'left-[calc(75%-2px)]',
      tickText: '> P75',
      footerText: `A score of ${score} is greater than the scores of 75% of recent visitors.`,
    }
  }

  return {
    activeLine: 'red',
    tickColor: 'bg-red-900',
    tickPosition: 'left-[calc(95%-2px)]',
    tickText: '> P95',
    footerText: `A score of ${score} is greater than the scores of 95% of recent visitors.`,
  }
}
